import { snackbarTypes } from "../../../util/state/globalVariables";
import { setSnackbar } from '../../../util/state/globalAction';

export const extractValueByTargetObjKeys = (target: any, source: any): any => {
	for (const key of Object.keys(target)) {
		if (!!source[key]) {
			target[key] = source[key];
		}
	}

	return target;
}

export const SNACKBAR = {
	LOADING: {
		message: 'Loading..',
		type: snackbarTypes.loading,
		show: true,
		autoClose: false
	},
	ERROR: {
		message: 'Error',
		type: snackbarTypes.error,
		show: true,
		autoClose: true,
	},
	SUCCESS: {
		message: 'Success',
		type: snackbarTypes.success,
		show: true,
		autoClose: true
	},
	WARNING: {
		message: 'Warning',
		type: snackbarTypes.warning,
		show: true,
		autoClose: true
	},
	HIDE: {
		message: '',
		type: snackbarTypes.loading,
		show: false,
		autoClose: false,
	},
	FORM_ERROR: {
		message: "Sono presenti errori nel form.",
		type: snackbarTypes.error,
		show: true,
		autoClose: true,
	}
}


export const SET_SNACKBAR = {
	ERROR: {
		type: setSnackbar,
		payload: {
			snackbar: SNACKBAR.ERROR
		}
	},
	LOADING: {
		type: setSnackbar,
		payload: {
			snackbar: SNACKBAR.LOADING
		}
	},
	SUCCESS: {
		type: setSnackbar,
		payload: {
			snackbar: SNACKBAR.SUCCESS
		}
	},
	FORM_ERROR: {
		type: setSnackbar,
		payload: {
			snackbar: SNACKBAR.FORM_ERROR
		}
	}
}
